const onChangeInput = (e,formData, setFormData) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type !== "checkbox" ? value : checked });
}

export { onChangeInput };